import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import * as Fa6Icons from 'react-icons/fa6';
import SafeIcon from '../common/SafeIcon';

const socialLinks = [
  {
    href: 'https://www.threads.com/@homy.hk',
    label: 'Threads',
    icon: Fa6Icons.FaThreads,
    emoji: null,
  },
  {
    href: 'https://www.instagram.com/homy.hk',
    label: 'Instagram',
    icon: FiIcons.FiInstagram,
    emoji: null,
  },
  {
    href: 'https://www.facebook.com/profile.php?id=61578745554661',
    label: 'Facebook',
    icon: FiIcons.FiFacebook,
    emoji: null,
  },
];

const footerLinks = [
  { path: '/about', nameZh: '關於我們', nameEn: 'About Us', icon: FiIcons.FiInfo },
  { path: '/features', nameZh: '功能介紹', nameEn: 'Features', icon: FiIcons.FiLayers },
  { path: '/help', nameZh: '使用幫助', nameEn: 'Help', icon: FiIcons.FiHelpCircle },
  { path: '/contact', nameZh: '聯絡我們', nameEn: 'Contact Us', icon: FiIcons.FiMail },
  { path: '/privacy', nameZh: '隱私政策', nameEn: 'Privacy Policy', icon: FiIcons.FiShield },
  { path: '/terms', nameZh: '使用條款', nameEn: 'Terms of Service', icon: FiIcons.FiFileText },
];

const Footer = ({ language }) => {
  return (
    <motion.footer
      className="mt-12 pb-6 border-t border-love-100 dark:border-gray-800 pt-6"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.5 }}
    >
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        {footerLinks.map((link, index) => (
          <Link
            key={index}
            to={link.path}
            className="text-gray-600 hover:text-love-500 dark:text-gray-400 dark:hover:text-love-400 transition-colors duration-200 flex items-center"
          >
            <SafeIcon icon={link.icon} className="mr-1 text-xs" />
            <span>{language === 'zh' ? link.nameZh : link.nameEn}</span>
          </Link>
        ))}
      </div>

      <div className="flex items-center justify-center gap-4 mb-5">
        {socialLinks.map((social) => (
          <motion.a
            key={social.label}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.label}
            className="flex items-center justify-center w-9 h-9 rounded-full bg-love-50 dark:bg-gray-800 hover:bg-love-100 dark:hover:bg-gray-700 text-love-500 dark:text-love-400 border border-love-100 dark:border-gray-700 transition-all duration-200"
            whileHover={{ scale: 1.15, y: -2 }}
            whileTap={{ scale: 0.95 }}
          >
            <SafeIcon icon={social.icon} className="text-base" />
          </motion.a>
        ))}
      </div>

      <div className="copyright text-gray-500 dark:text-gray-400 flex items-center justify-center">
        <span className="logo-paw mr-2">🐾</span>
        <a
          href="https://homy.hk"
          target="_blank"
          rel="noopener noreferrer"
          className="homy-logo hover:text-love-500 transition-colors duration-300"
          aria-label="Visit Homy Tech Limited website"
        >
          Homy Tech Limited
        </a>
        <span className="logo-paw ml-2">🐾</span>
      </div>

      <div className="mt-4 text-xs text-center text-gray-400 dark:text-gray-500">
        <p>© {new Date().getFullYear()} {language === 'zh' ? '寵物紀念日計算器 - 記錄毛孩美好時刻' : 'Pet Anniversary Calculator - Recording Precious Pet Moments'}</p>
      </div>
    </motion.footer>
  );
};

export default Footer;